<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="descriptive-sheet-header white">
  <div class="descriptive-sheet-header-ghost" cdkDragHandle></div>

  <ng-container *ngIf="getModalIcon() as modalIcon">
    <img [src]="modalIcon" alt="" srcset="" class="dialog-title-start-icon" style="margin-top: 4px;height: 25px;">
  </ng-container>

  <span class="dialog-title-text">
    <i class="fa fa-arrows-alt white" style="font-size:20px" aria-hidden="true"></i>
    {{ getModalName()}}
  </span>
  <i class="fa fa-times-circle dialog-title-end-icon" (click)="closeModal()"></i>

</h1>

<ng-container *ngIf="{ entities:entities$|async} as context">

  <div style="position: relative;margin-top: 10px;" *ngIf="featureInfoIsLoading">
    <div style="position:absolute;top:calc(50% - 30px);left:40%">
      <div class="lds-ripple" style="width: 100px;
height: 100px;">
        <div></div>
        <div></div>
      </div>
    </div>
  </div>



  <ng-container *ngIf="context.entities != undefined">
    <div class="chip-container" [style.display]="context.entities.length == 1 ? 'none' : 'flex'">
      <mat-chip-listbox [multiple]="false" color="accent" selectable>
        <mat-chip-option *ngFor="let entity of context.entities ; let index = index" [value]="entity"
          [selected]="index==0" (selectionChange)="onChipSelectionChange($event, entity)">
          {{getFeatureName(entity)}}
        </mat-chip-option>
      </mat-chip-listbox>
    </div>

    <ng-container *ngIf="selectedEntity && selectedEntityKey">
      <app-osm-sheet *ngIf="selectedEntity.data.type == 'osm' " [feature]="selectedEntity.feature"
        [dataOsmLAyer]="selectedEntity.dataOsmLAyer" [coord]="selectedEntity.data.coordinates_3857"
        [object]="selectedEntity.data.object" [map]="selectedEntity.data.map"></app-osm-sheet>

      <app-building-sheet *ngIf="selectedEntity.data.type == 'building' " [feature]="selectedEntity.feature"
        [coord]="selectedEntity.data.coordinates_3857" [object]="selectedEntity.data.object"
        [map]="selectedEntity.data.map" (closeModal)="closeModal()"> </app-building-sheet>
    </ng-container>

  </ng-container>

</ng-container>